import { render, staticRenderFns } from "./InputWithLabel.vue?vue&type=template&id=2966fdca&scoped=true&lang=pug&"
import script from "./InputWithLabel.vue?vue&type=script&lang=ts&"
export * from "./InputWithLabel.vue?vue&type=script&lang=ts&"
import style0 from "./InputWithLabel.vue?vue&type=style&index=0&id=2966fdca&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2966fdca",
  null
  
)

export default component.exports